import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core'
import { FileUploadService } from '../../services/file-upload.service'
import { DialogService } from '../../../core/services/dialog.service'
import { DocumentUploadViewModeEnum } from './document-upload-view-mode.enum'

@Component({
    selector: 'ca-document-upload',
    template: `
        <input type="file"
               class="component-fileButton_hidden"
               id="file-upload"
               (change)="onFileSelected($event.target)"
               (click)="onFileClick()"
               #fileUpload>
        <ng-container *ngIf="viewMode === documentUploadViewModeEnum.PLUS_BUTTON || viewMode === documentUploadViewModeEnum.FLASK_ICON">
            <a  class="fa {{viewMode.valueOf()}}"
                [ngClass]="{'rd_boxbutton': boxButton}"
                [title]="title"
                (click)="fileUpload.click()">
            </a>
        </ng-container>
        <label *ngIf="viewMode === documentUploadViewModeEnum.LABEL_BUTTON"
            class="component-fileButton_button"
            [ngClass]="{'component-fileButton_comboButton' : viewMode === documentUploadViewModeEnum.LABEL_BUTTON}"
            (click)="fileUpload.click()">
            {{title}}
        </label>
    `,
})
export class DocumentUploadComponent {

    @Input() title: string
    @Input() boxButton: boolean
    @Input() viewMode: DocumentUploadViewModeEnum = DocumentUploadViewModeEnum.PLUS_BUTTON
    @Output() fileSelected = new EventEmitter<File>()

    @ViewChild('fileUpload') private fileUpload: ElementRef

    public documentUploadViewModeEnum: typeof DocumentUploadViewModeEnum = DocumentUploadViewModeEnum

    constructor(
        @Inject(FileUploadService) private fileUploadService: FileUploadService,
        @Inject(DialogService) private dialogService: DialogService,
    ) {
    }

    onFileClick(): void {
        this.fileUpload.nativeElement.value = null
    }

    onFileSelected(target: EventTarget): void {
        const file = (<HTMLInputElement>target).files[0]
        if (!file) {
            return
        }
        if (this.fileUploadService.hasValidSize(file)) {
            this.fileSelected.emit(file)
        } else {
            this.dialogService.showWarningDialog('Vybraný soubor je příliš velký! Maximální velikost je ' + this.fileUploadService.MAX_TOTAL_FILE_SIZE_MB + 'MB.')
        }
    }

}
